var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"light-theme",class:{'header-closed': _vm.hideUi}},[_c('app-header'),_c('v-main',{staticClass:"theme-background"},[_c('v-container',{staticClass:"no-gutters pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }